/**
 * Abas de `/cadastros` (spec 004, CA-01). Ficam fora dos componentes porque a rota as usa no
 * `validateSearch`, que vai no pacote da primeira tela: importar o componente levaria a tela junto.
 */
export const ABAS_DE_CADASTRO = [
  'tipos-atendimento',
  'categorias-ficha',
  'equipamentos',
  // Spec 023: todas as tags da academia.
  'tags',
] as const;

export type AbaDeCadastro = (typeof ABAS_DE_CADASTRO)[number];

/** Abas de `/plataforma/cadastros` (spec 014, CA-05): o catálogo global. */
export const ABAS_GLOBAIS = ['equipamentos'] as const;
export type AbaGlobal = (typeof ABAS_GLOBAIS)[number];
